import { throttle } from '../../utils';

const filters = async () => {
  let isWaiting = false;

  const handleGeolocation = async (option, container) => {
    let value = option.getAttribute('data-value') || option.getAttribute('value');

    if (value === 'geolocation') {
      if (navigator.geolocation) {
        isWaiting = true;

        await navigator.geolocation.getCurrentPosition(
          (position) => {
            container.setAttribute('lat', position.coords.latitude);
            container.setAttribute('lng', position.coords.longitude);

            isWaiting = false;
          },
          (error) => {
            container.removeAttribute('lat');
            container.removeAttribute('lng');

            // Reset location select to placeholder
            const selectRoot = option.closest('[data-select]');
            const native = selectRoot?.querySelector('.a-select__native');
            const trigger = selectRoot?.querySelector('.js-selectTrigger');
            const valueSpan = trigger?.querySelector('.a-select__value');

            if (native) {
              native.value = '';
            }

            if (valueSpan) {
              const placeholder = native?.querySelector('option[disabled]');

              valueSpan.textContent = placeholder ? placeholder.textContent.trim() : '';
              valueSpan.classList.add('-placeholder');
            }

            selectRoot?.querySelectorAll('.a-select__option').forEach((opt) => {
              opt.classList.remove('-selected');
              opt.setAttribute('aria-selected', 'false');
            });

            console.error('Error obtaining geolocation:', error);
            isWaiting = false;
          },
        );
      }
    } else {
      container.removeAttribute('lat');
      container.removeAttribute('lng');
    }
  };

  const handleParams = (baseUrl) => {
    baseUrl.searchParams.delete('page');
    baseUrl.searchParams.sort();

    window.history.replaceState({}, '', baseUrl);
    window.location.href = baseUrl;
  };

  // Checkbox and Select value
  const filterItems = document.querySelectorAll('.js-filter-link, .js-filter-additional');

  if (filterItems.length > 0) {
    filterItems.forEach((option) => {
      option.addEventListener('click', async (e) => {
        if (option.type !== 'checkbox') {
          e.preventDefault();
        }

        const container = option.closest('.m-filters');
        const name = option.getAttribute('data-name') || option.getAttribute('name');
        let value = option.getAttribute('data-value') || option.getAttribute('value');

        // CASE: Geolocation
        if (name === 'location') {
          handleGeolocation(option, container);

          await new Promise((resolve, reject) => {
            const MAX_ATTEMPTS = 40; // 40 × 250ms = 10s max
            let attempts = 0;

            const interval = setInterval(() => {
              attempts++;

              if (!isWaiting) {
                clearInterval(interval);
                resolve();
              } else if (attempts >= MAX_ATTEMPTS) {
                clearInterval(interval);
                reject(new Error('Geolocation polling timed out'));
              }
            }, 250);
          });
        }

        // Variant "Link"
        if (option.classList.contains('js-filter-link')) {
          const baseUrl = new URL(window.location.href);

          if (option.type === 'checkbox') {
            value = option.checked ? value : '';
          }

          // CASE: Remove filter
          if (value === '' || value === null) {
            baseUrl.searchParams.delete(name);

            if (name === 'location') {
              baseUrl.searchParams.delete('lat');
              baseUrl.searchParams.delete('lng');
            }

            handleParams(baseUrl);
          } else {
            // CASE: Geolocation
            if (name === 'location') {
              baseUrl.searchParams.set(name, value);

              if (value === 'geolocation') {
                baseUrl.searchParams.set('lat', container.getAttribute('lat'));
                baseUrl.searchParams.set('lng', container.getAttribute('lng'));
              } else {
                baseUrl.searchParams.delete('lat');
                baseUrl.searchParams.delete('lng');
              }
            } else {
              baseUrl.searchParams.set(name, value);
            }

            handleParams(baseUrl);
          }
        }
      });
    });
  }

  // Variant "Additional": cumulative filters with search button
  const searchButtons = document.querySelectorAll('.js-filter-search');

  searchButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const container = button.closest('.m-filters');

      if (!container) {
        return;
      }

      const baseUrl = new URL(window.location.pathname, window.location.origin);

      // Collect select values
      container.querySelectorAll('.a-select__native').forEach((select) => {
        if (select.value && select.name) {
          baseUrl.searchParams.set(select.name, select.value);
        }
      });

      // Collect checked checkbox values
      container
        .querySelectorAll('input[type="checkbox"].js-filter-additional')
        .forEach((checkbox) => {
          if (checkbox.checked && checkbox.name) {
            baseUrl.searchParams.set(checkbox.name, checkbox.value);
          }
        });

      // Add stored geolocation coordinates if available
      if (container.hasAttribute('lat') && container.hasAttribute('lng')) {
        baseUrl.searchParams.set('location', 'geolocation');
        baseUrl.searchParams.set('lat', container.getAttribute('lat'));
        baseUrl.searchParams.set('lng', container.getAttribute('lng'));
      }

      handleParams(baseUrl);
    });
  });

  // Mobile collapsible toggle
  const MD_MAX = 900;
  const filterToggles = document.querySelectorAll('.js-filters-toggle');

  filterToggles.forEach((toggle) => {
    const filtersRoot = toggle.closest('.m-filters');

    if (!filtersRoot) {
      return;
    }

    const container = filtersRoot.querySelector('.m-filters__container');

    // If already open on page load (server-rendered with active filters), allow overflow immediately
    if (filtersRoot.classList.contains('-open')) {
      filtersRoot.classList.add('-expanded');
    }

    const open = () => {
      filtersRoot.classList.add('-open');
      toggle.setAttribute('aria-expanded', 'true');

      // Wait for the expand animation to finish before allowing overflow
      container.addEventListener(
        'transitionend',
        () => {
          if (filtersRoot.classList.contains('-open')) {
            filtersRoot.classList.add('-expanded');
          }
        },
        { once: true },
      );
    };

    const close = () => {
      filtersRoot.classList.remove('-expanded');
      filtersRoot.classList.remove('-open');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', () => {
      if (filtersRoot.classList.contains('-open')) {
        close();
      } else {
        open();
      }
    });

    window.addEventListener(
      'resize',
      throttle(() => {
        if (window.innerWidth > MD_MAX && filtersRoot.classList.contains('-open')) {
          close();
        }
      }, 100),
    );
  });
};

export default filters;
